import React, { Component } from 'react';

class Invalid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logo: null
    }
  }

  componentDidMount() {
    if (localStorage.logo && localStorage.logo !== 'undefined') {
      this.setState({logo: localStorage.logo})
    }
  }

  render() {
      //console.log('state: ', this.state, 'props: ', this.props);
    const logo = this.state.logo;

    return (
      <div className="genericAppInner">
        <div className="page">
          <div className="verticalWrap contentWrap">
            <div className="innerWrap">
              <h2 className="invalid">Sorry, but this offer has been redeemed or is expired.</h2>
              <img className="topSpace" src={logo} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Invalid;



// WEBPACK FOOTER //
// ./src/components/Invalid.js